// extracted by mini-css-extract-plugin
export default {"skeleton":"rzpHXow0","item":"o_TsGrMX"};